export const LOCALES = [
  'en',
  'ru',
  // 'ar', // temporarily disabled
  'de',
  'es',
  // 'fa', // temporarily disabled
  'fr',
  // 'hi', // temporarily disabled
  'hu',
  'it',
  'ja',
  'pt'
  // 'tr' // temporarily disabled
] as const

export const DEFAULT_LOCALE = 'en'

export type Locale = (typeof LOCALES)[number]
